import { RuntimeComponent } from '@easytwin/runtime';

export function getTypeVersionClassNameKey(type: string, version: string, className: string) {
  return type + '@' + version + '-' + className;
}

export function getTypeVersionKey(type: string, version: string) {
  return type + '@' + version;
}

export function deepClone(obj: undefined): undefined;
export function deepClone<T>(obj: T): T;

export function deepClone<T>(obj: T | undefined): T | undefined {
  if (obj === undefined) return undefined;
  return JSON.parse(JSON.stringify(obj)) as T;
}

export function flatRuntimeComponent(comp: RuntimeComponent | RuntimeComponent[]) {
  const res: RuntimeComponent[] = [];
  const helper = (comp: RuntimeComponent) => {
    res.push(comp);
    comp.shownChildren.forEach((a) => helper(a));
  };

  Array.isArray(comp) ? comp.forEach((c) => helper(c)) : helper(comp);
  return res;
}

export function deepFilter<T extends Record<string, any>, K extends keyof T>(
  data: T[],
  predicate: (item: T) => boolean,
  mapKey: K,
): T[] {
  return data.reduce((all, item) => {
    const isTrue = predicate(item);
    const children = deepFilter(item[mapKey], predicate, mapKey);
    if (isTrue || children.length > 0) {
      all.push({
        ...item,
        [mapKey]: children,
      });
      return all;
    }
    return all;
  }, [] as T[]);
}

export function extension(uri: string): string {
  return uri.split(/[\\/]/).pop()!.split(/[.]/).pop()!;
}

export function concatUrl(...paths: string[]): string {
  const a = paths.map((p) => {
    p = p.trim();
    if (p.endsWith('/')) {
      p = p.slice(0, p.length - 1);
    }
    if (p.startsWith('/')) {
      p = p.slice(1, p.length);
    }
    return p;
  });
  return a.join('/');
}

export function deepMap<
  T extends Record<string, any>,
  R extends Record<string, any>,
  K extends keyof T = keyof T,
>(data: T[], predicate: (arg: T) => R, deepKey: K): R[] {
  if (!Array.isArray(data)) {
    return data;
  }

  return data.reduce(
    (all, item) =>
      Object.prototype.hasOwnProperty.call(item, deepKey)
        ? all.concat({ ...predicate(item), [deepKey]: deepMap(item[deepKey], predicate, deepKey) })
        : all.concat({ ...predicate(item), [deepKey]: [] }),
    [] as R[],
  );
}
